import { useEffect, useRef } from 'react';
import gsap from 'gsap';

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isFine) return undefined;

    document.body.style.cursor = 'none';

    const dot = dotRef.current;
    const ring = ringRef.current;

    const dx = gsap.quickTo(dot, 'x', { duration: 0.12, ease: 'power3' });
    const dy = gsap.quickTo(dot, 'y', { duration: 0.12, ease: 'power3' });
    const rx = gsap.quickTo(ring, 'x', { duration: 0.55, ease: 'power3' });
    const ry = gsap.quickTo(ring, 'y', { duration: 0.55, ease: 'power3' });

    const move = (e) => {
      dx(e.clientX - 3);
      dy(e.clientY - 3);
      rx(e.clientX - 17);
      ry(e.clientY - 17);
    };

    const over = (e) => {
      const hit = e.target.closest && e.target.closest('a,button,input,textarea,[data-tilt]');
      gsap.to(ring, {
        scale: hit ? 1.9 : 1,
        borderColor: hit ? 'rgba(168,85,247,.8)' : 'rgba(0,245,255,.55)',
        duration: 0.3,
      });
    };

    window.addEventListener('mousemove', move);
    window.addEventListener('mouseover', over);

    return () => {
      document.body.style.cursor = '';
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseover', over);
    };
  }, []);

  return (
    <>
      <div
        ref={ringRef}
        aria-hidden="true"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: 34,
          height: 34,
          border: '1px solid rgba(0,245,255,.55)',
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 9999,
          transform: 'translate(-100px,-100px)',
          mixBlendMode: 'screen',
        }}
      />
      <div
        ref={dotRef}
        aria-hidden="true"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: 'var(--cy)',
          boxShadow: '0 0 12px 2px rgba(0,245,255,.9)',
          pointerEvents: 'none',
          zIndex: 10000,
          transform: 'translate(-100px,-100px)',
        }}
      />
    </>
  );
}
